import { render, staticRenderFns } from "./salesUDIscanCode.vue?vue&type=template&id=5e128555&scoped=true"
import script from "./salesUDIscanCode.vue?vue&type=script&lang=js"
export * from "./salesUDIscanCode.vue?vue&type=script&lang=js"
import style0 from "./salesUDIscanCode.vue?vue&type=style&index=0&id=5e128555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e128555",
  null
  
)

export default component.exports